/**
 * Default agent name used as the pre-filled value in the name input.
 * The backend soul builder only includes the name when explicitly set —
 * this constant is purely a frontend UI default.
 */
export const DEFAULT_AGENT_NAME = 'Lisa';

/**
 * Locale-independent tone keys used as the persisted value for botTone.
 * Display labels are resolved via t(`smartLeadbot.botPersonality.tones.${key}.label`).
 */
export const TONE_KEYS = ['casual', 'professional', 'formal'] as const;

export type tToneKey = (typeof TONE_KEYS)[number];

export const DEFAULT_TONE: tToneKey = 'professional';

/**
 * Maps a locale-independent tone key to the legacy display string that was
 * previously persisted. Used only for backward-compatible reads from localStorage.
 */
export const TONE_DISPLAY_VALUES: Record<tToneKey, string> = {
  casual: 'Casual y amigable',
  professional: 'Profesional',
  formal: 'Formal',
};

/**
 * Maps the onboarding integration selection key to the API activeIntegrations
 * array expected by chatbot-service. When new channels (Instagram, Messenger)
 * ship, add entries here so the mapping is discoverable.
 */
export const INTEGRATION_TO_API_MAP: Record<string, string[]> = {
  whatsapp: ['WHATSAPP_API'],
};

/**
 * All valid tone values (both new keys and legacy display strings) for
 * backward-compatible matching.
 */
export const ALL_TONE_VALUES: string[] = [
  ...TONE_KEYS,
  ...Object.values(TONE_DISPLAY_VALUES),
];
